import Axios from "./index";

const path = '/reports';

export function getAllReports() {
  return Axios.get(`${path}`);
}
